module.exports = __webpack_public_path__ + "img/img25.5fc687c3.png";